import { makeStyles } from "@material-ui/core";
import React from "react";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  activeTabTrash: {
    backgroundColor: "rgba(255, 53, 53, 0.40) !important",
    color:"#FF353580 !important"
  },
  activeTab:{
    background: "#D3E6FA !important",
    color:"#3699FF !important"
  }
}));

const TabButtons = ({ tabs = [], onTabChage = () => console.log('Tab Changed') }) => {
  const classes = useStyles();
  return (
    <div className="tabButtons gridBody contentBody" 
    style={{
      padding:"unset !important",
      borderRadius:"unset",
      background:"unset"
    }}
    >
      {tabs.map((tab) => (
        <span
          className={"tab-button"}
          key={tab.title}
          onClick={() => onTabChage()}
        >
          <NavLink
            to={tab.to}
           activeClassName={tab.title === "Trash" ? classes.activeTabTrash : classes.activeTab}
          >
            {tab.title}
          </NavLink>
        </span>
      ))}
    </div>
  );
};

export { TabButtons };
